<template>
    <div>
        <portal to="buttons">

        </portal>

        <b-card no-body>
            <data-table ref="dataTable" url="/api/products" :columns="columns" :filter.sync="filter" cache-search="tableProducts">

                <template #filter>
                    <v-select v-model="filter.categories" :options="categories" @search="fetchCategories" multiple placeholder="Vælg kategori" :filterable="false">
                        <template slot="option" slot-scope="option">
                            {{ option.name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ option.name }}
                        </template>
                    </v-select>

                    <v-select v-model="filter.brands" :options="brands" @search="fetchBrands" multiple placeholder="Vælg mærke" :filterable="false">
                        <template slot="option" slot-scope="option">
                            {{ option.name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ option.name }}
                        </template>
                    </v-select>
                </template>

                <template #Name="data">
                    <b-link :to="data.item.Id" append>{{data.value}}</b-link>
                </template>

                <template #Inactive="data">
                    <feather-icon v-if="!data.value" icon="CheckCircleIcon" size="18" />
                    <feather-icon v-else icon="CircleIcon" size="18" />
                </template>

                <template #CreateDate="data">
                    <span class="text-nowrap">
                        {{ $moment(data.value).format("DD. MMM YYYY") }}
                    </span>
                </template>

                <template #actions="data">
                    <div class="text-nowrap">
                        <b-link :to="{ name: 'product', params: { id: data.item.Id } }">
                            <feather-icon icon="EditIcon" size="16" class="mx-6 my-2" />
                        </b-link>

                        <b-button @click="deleteItem(data.item)" variant="link" class="p-0">
                            <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                        </b-button>
                    </div>
                </template>

            </data-table>
        </b-card>
    </div>
</template>

<script>
    import DataTable from "@/components/DataTable.vue"
    import Toast from '@/components/_toast.vue'

    export default {
        components: {
            DataTable
        },
        data: () => ({
            filter: {},
            columns: [
                //{ key: 'id', label: '#', sortable: true },
                { key: 'Name', label: 'Navn', sortable: true, stickyColumn: false },
                { key: 'SKU', label: 'Varenummer', sortable: true },
                { key: 'GTIN', label: 'Stregkode', sortable: true },
                { key: 'GTIN_SW', label: 'GTIN', sortable: true },
                { key: 'Inactive', label: 'Aktiv', sortable: true },
                { key: 'CreateDate', label: 'Oprettet', sortable: true },
                { key: 'actions', label: '', class: "text-right" },
            ],
            categories: [],
            brands: []
        }),
        computed: {},
        created() {
            this.fetchCategories("", () => { })
            this.fetchBrands("", () => { })
        },
        mounted() { },
        methods: {
            deleteItem(item) {
                this.$swal({
                    title: 'Er du sikker?',
                    text: "Dette sletter " + item.Name,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Jeg er sikker',
                    cancelButtonText: 'Fortryd',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-7',
                    },
                    buttonsStyling: false,
                }).then(result => {
                    if (result.value) {
                        var icon, message, variant

                        this.$http.post("/api/products/delete/" + item.Id).then(x => {
                            icon = "CheckCircleIcon"
                            message = x.data
                            variant = "success"
                        }).catch(x => {
                            icon = "AlertTriangleIcon"
                            message = x.data
                            variant = "danger"
                        }).then(() => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: message,
                                    icon: icon,
                                    variant: variant,
                                },
                            })

                            this.$refs.dataTable.refresh()
                        })

                    } else if (result.dismiss === 'cancel') { }
                })
            },
            fetchCategories(search, loading) {
                loading(true)

                this.$http.get("/api/categories", {
                    params: {
                        search: search
                    }
                }).then(x => {
                    this.categories = x.data
                    loading(false)
                })
            },
            fetchBrands(search, loading) {
                loading(true)

                this.$http.get("/api/brands", {
                    params: {
                        search: search
                    }
                }).then(x => {
                    this.brands = x.data
                    loading(false)
                })
            }

        },
    }
</script>